import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ListPage from './Pages/List/Index';
import CreatePage from './Pages/Create/Index';
import UpdatePage from './Pages/Update/Index';

export default function Index() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/avatars" element={<ListPage />} />
        <Route path="/admin/avatars/new" element={<CreatePage />} />
        <Route path="/admin/avatars/:id/edit" element={<UpdatePage />} />
      </Routes>
    </Router>
  );
}
